const Favorites = () => {
    return (
        <>
            Favorites Page
        </>
    )
}

export default Favorites;